import React from 'react';
import axios from 'axios';

import Layout from '../../../components/Layout';
import Page from '../../../components/Page';
import PartnerPrivacyPolicy from './PartnerPrivacyPolicy';

import { siteUrl } from '../../../config'
import { getEditStaticPage } from '../../../lib/graphql';


async function action({ locale }) {
    const dataResult = await new Promise((resolve) => {
        require.ensure([], (require) => {
            try {
                resolve(require(`./partnerPrivacyPolicy.${locale}.md`));
            } catch (e) {
                resolve(require('./partnerPrivacyPolicy.md'));
            }
        }, 'partnerPrivacyPolicy');
    });

    const response = await axios.post(`${siteUrl}/graphql`, {
        query: getEditStaticPage,
        variables: { id: 4 }
    }, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        withCredentials: true
    })

    const { data } = await response?.data;

    if (data?.getEditStaticPage?.result) {
        return {
            title: data?.getEditStaticPage?.result?.metaTitle,
            description: data?.getEditStaticPage?.result?.metaDescription,
            component: <Layout><PartnerPrivacyPolicy data={data} containerClass="contentPageWrapper" /></Layout>,
        };
    } else {
        return {
            title: dataResult?.title,
            component: <Layout><Page {...dataResult} containerClass="contentPageWrapper" /></Layout>,
        };
    }
}

export default action